import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=ef62e358&scoped=true"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"
import style0 from "./remote.vue?vue&type=style&index=0&id=ef62e358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef62e358",
  null
  
)

export default component.exports